import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class StreetNumberInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'StreetNumber',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = this.retrieveStreetNumberFromAddress(params.addressInformation.userAddress)
  }

  retrieveStreetNumberFromAddress (address) {
    const words = address.split(' ')
    return words.slice(-1).join(' ')
  }
}
